<template>
  <div class="main pb-x8">
    <PageLoader :isActive="isLoading"/>
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col">
          <button @click="goBack" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim mb-x2">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </button>
          <div class="h5">
            {{ eventData.event_name }}
          </div>
          <h2 v-if="!editMode">Create a Shot</h2>
          <h2 v-else>Edit Shot</h2>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col zero-form">
          <div class="input-block mb-x2" v-if="!zohoMode">
            <label for="shot-general" class="mb-x1">
              what type of shot is this?
            </label>
            <div class="zero-btn zero-btn-standard zero-btn-primary zero-btn-toggle" @click="shotData.general = ''" :class="{ 'zero-btn-outline' : shotData.general }">
              Assigned Shot
            </div>
            <div class="zero-btn zero-btn-standard zero-btn-primary zero-btn-toggle" @click="shotData.general = '1'" :class="{ 'zero-btn-outline' : !shotData.general }">
              General Shot
            </div>
          </div>
          <template v-if="!shotData.general">
            <div class="input-block mb-x2">
              <label for="shot-date">
                date
              </label>
              <input
                type="date"
                id="day-date"
                name="day-date"
                placeholder=""
                class="date-input"
                v-model="shotData.date"
                :class="{ 'has-error': errors.date }"
                autocomplete="off"
              >
              <p class="input-error" v-if="errors.start">
                Please enter a date for the day
              </p>
            </div>
            <div class="input-block mb-x2">
              <label for="shot-start">
                start time
              </label>
              <input
                type="time"
                id="shot-start"
                name="shot-start"
                placeholder=""
                class="date-input"
                v-model="shotData.start_time"
                :class="{ 'has-error': errors.start }"
                autocomplete="off"
              >
              <p class="input-error" v-if="errors.end">
                Please enter a starting time for the day
              </p>
            </div>
            <div class="input-block mb-x2">
              <label for="shot-end">
                end time
              </label>
              <input
                type="time"
                id="shot-end"
                name="shot-end"
                placeholder=""
                class="standard-date-input date-input"
                v-model="shotData.end_time"
                :class="{ 'has-error': errors.end }"
                autocomplete="off"
              >
              <p class="input-error" v-if="errors.end">
                Please enter an ending time for the day
              </p>
            </div>
            <div class="input-block mb-x2">
              <label for="location">
                creatives
              </label>
              <CreativesList v-if="users.length !== 0" :allUsers="users" :creatives="shotData.creatives" picker @selectedCreatives="setCreatives" />
            </div>
            <div class="input-block mb-x2">
              <label for="shot-location">
                location
              </label>
              <input
                type="text"
                id="shot-location"
                name="shot-location"
                placeholder=""
                class="standard-text-input"
                v-model="shotData.location"
                :class="{ 'has-error': errors.location }"
                autocomplete="off"
              >
              <p class="input-error" v-if="errors.location">
                Please enter a location.
              </p>
            </div>
            <div class="input-block mb-x2">
              <label for="shot-event">
                event/session
              </label>
              <input
                type="text"
                id="shot-event"
                name="shot-event"
                placeholder=""
                class="standard-text-input"
                v-model="shotData.event"
                :class="{ 'has-error': errors.contact }"
                autocomplete="off"
              >
            </div>
            <div class="input-block mb-x2">
              <label for="shot-contact">
                session contact
              </label>
              <input
                type="text"
                id="shot-contact"
                name="shot-contact"
                placeholder=""
                class="standard-text-input"
                v-model="shotData.contact"
                :class="{ 'has-error': errors.contact }"
                autocomplete="off"
              >
            </div>
          </template>
          <div class="input-block mb-x2">
            <label for="shot-notes">
              <template v-if="shotData.general">Description</template><template v-else>notes</template>
            </label>
            <textarea
              id="shot-notes"
              name="shot-notes"
              placeholder=""
              class="standard-text-area"
              v-model="shotData.notes"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="zero-btn zero-btn-standard zero-btn-primary" @click="postShot()" v-if="!editMode">
            Create Shot
          </div>
          <div class="zero-btn zero-btn-standard zero-btn-primary" @click="putShot()" v-if="editMode">
            Update Shot
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'
import CreativesList from '@/components/CreativesList.vue'
import PageLoader from '@/components/PageLoader.vue'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'home',
  components: {
    Nav,
    CreativesList,
    PageLoader
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      eventId: '',
      shotId: '',
      eventData: {
        'event_name': '',
        'start_date': '',
        'end_date': '',
        'location': '',
        'floorplan_path': ''
      },
      shotData: {
        'title': '',
        'date': '',
        'creatives': '',
        'location': '',
        'contact': '',
        'notes': '',
        'general': '',
        'done': false,
        'start_time': '',
        'end_time': '',
        'event_id': '',
        'meeting_room': '',
        'event': ''
      },
      errors: {
        'date': false,
        'start': false,
        'end': false
      },
      editMode: false,
      users: [],
      zohoMode: false
    }
  },
  created () {
    // get the jwt
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.eventid) {
      if (this.$route.params.eventid.slice(0, 1) === 'z') {
        this.shotData.general = 1
        this.zohoMode = true
        this.eventId = this.$route.params.eventid.slice(1)
      } else {
        this.eventId = this.$route.params.eventid
        this.getEvent()
      }
    } else {
      this.$router.go(-1)
    }
    if (this.$route.params.shotid) {
      this.shotId = this.$route.params.shotid
      this.editMode = true
      this.getShot()
    }
  },
  methods: {
    getEvent () {
      axios
        .get(apiChoice + 'api/events/' + this.eventId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.eventData = response.data
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    getShot () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/shots/' + this.shotId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.shotData = response.data
          this.getUsers()
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    postShot () {
      this.isLoading = true
      this.shotData.event_id = this.eventId
      this.shotData.extratwo = 'zohomanuallyadded'
      axios
        .post(apiChoice + 'api/shots', this.shotData, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // do something with response.data.data
          if (this.zohoMode) {
            this.$router.push({ path: '/jobs/z' + this.eventId + '/zshotlist' })
          } else {
            this.$router.push({ path: '/jobs/' + this.eventId + '/shots' })
          }
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    putShot () {
      this.isLoading = true
      axios
        .put(apiChoice + 'api/shots/' + this.shotId, this.shotData, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // do something with response.data.data
          if (this.zohoMode) {
            this.$router.push({ path: '/jobs/z' + this.eventId + '/zshotlist' })
          } else {
            this.$router.push({ path: '/jobs/' + this.eventId + '/shots' })
          }
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getUsers () {
      this.isLoading = true
      axios
        .get(apiChoice + 'api/users', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // transfer the response
          this.users = response.data
          let creativesArray = this.eventData.creatives.replace(/\s+/g, '').split(',')
          this.users = this.users.filter((user) => creativesArray.includes(user.email))
        })
        .catch((error) => {
          console.log(error.response.data)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    goBack () {
      // if profile => back to profile
      // if user create => back to users
      // if user edit => back to users dets
      if (this.zohoMode) {
        this.$router.push({ path: '/jobs/z' + this.eventId + '/zshotlist' })
      } else {
        this.$router.push({ path: '/jobs/' + this.eventId + '/shots' })
      }
    },
    setCreatives (selectedCreatives) {
      this.shotData.creatives = selectedCreatives
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
